document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.cb-faq-tabs');

  sections.forEach(function (section) {
    var tabs = section.querySelectorAll('.cb-faq-tabs__tab');
    var groups = section.querySelectorAll('.cb-faq-tabs__group');
    var cta = section.querySelector('[data-faq-cta]');
    var ctaText = section.querySelector('[data-faq-cta-text]');
    var ctaDataScript = section.querySelector('[data-faq-cta-data]');
    var ctaData = {};

    if (ctaDataScript) {
      try {
        ctaData = JSON.parse(ctaDataScript.textContent);
      } catch (e) {
        ctaData = {};
      }
    }

    function updateCTA(topicKey) {
      if (!cta || !ctaText || !ctaData[topicKey]) return;

      var topicCTA = ctaData[topicKey];

      ctaText.textContent = topicCTA.text || '';

      if (topicCTA.link) {
        cta.setAttribute('href', topicCTA.link);
      } else {
        cta.setAttribute('href', '#');
      }

      if (topicCTA.new_tab) {
        cta.setAttribute('target', '_blank');
        cta.setAttribute('rel', 'noopener noreferrer');
      } else {
        cta.removeAttribute('target');
        cta.removeAttribute('rel');
      }

      if (!topicCTA.text || !topicCTA.link) {
        cta.style.display = 'none';
      } else {
        cta.style.display = 'inline-flex';
      }
    }

    function closeAllInGroup(group) {
      var items = group.querySelectorAll('.cb-faq-tabs__item');
      items.forEach(function (item) {
        item.classList.remove('is-open');
        var button = item.querySelector('.cb-faq-tabs__question');
        var answer = item.querySelector('.cb-faq-tabs__answer-wrap');
        if (button) button.setAttribute('aria-expanded', 'false');
        if (answer) answer.hidden = true;
      });
    }

    function openItem(item) {
      item.classList.add('is-open');
      var button = item.querySelector('.cb-faq-tabs__question');
      var answer = item.querySelector('.cb-faq-tabs__answer-wrap');
      if (button) button.setAttribute('aria-expanded', 'true');
      if (answer) answer.hidden = false;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-faq-tab');

        tabs.forEach(function (otherTab) {
          otherTab.classList.remove('is-active');
          otherTab.setAttribute('aria-selected', 'false');
        });

        groups.forEach(function (group) {
          var isMatch = group.getAttribute('data-faq-group') === target;
          group.classList.toggle('is-active', isMatch);
          group.hidden = !isMatch;

          if (isMatch) {
            var openItems = group.querySelectorAll('.cb-faq-tabs__item.is-open');
            if (!openItems.length) {
              var firstItem = group.querySelector('.cb-faq-tabs__item');
              if (firstItem) openItem(firstItem);
            }
          }
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        updateCTA(target);
      });
    });

    groups.forEach(function (group) {
      var questions = group.querySelectorAll('.cb-faq-tabs__question');

      questions.forEach(function (questionButton) {
        questionButton.addEventListener('click', function () {
          var item = questionButton.closest('.cb-faq-tabs__item');
          var isOpen = item.classList.contains('is-open');

          closeAllInGroup(group);

          if (!isOpen) {
            openItem(item);
          }
        });
      });
    });

    var activeTab = section.querySelector('.cb-faq-tabs__tab.is-active');
    if (activeTab) {
      updateCTA(activeTab.getAttribute('data-faq-tab'));
    }
  });
});